import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import AreaForm from './AreaForm';

const message = defineMessages({
    objectName: 'Area',
});

const AreaSavePage = () => {
    const translate = useTranslate();
    const params = useParams();

    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('deviceId');
    const deviceName = queryParams.get('deviceName');
    const ordering = queryParams.get('ordering');
    const path = `?deviceId=${deviceId}&deviceName=${deviceName}`;

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.areas.getById,
            create: apiConfig.areas.create,
            update: apiConfig.areas.update,
        },
        options: {
            getListUrl: generatePath(routes.DeviceTab.path, { customerId: params.customerId }) + path,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    ordering: ordering ? Number(ordering) : undefined,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.managerKitplay),
                    path: routes.listKitPlayDevicePage.path,
                },
                {
                    breadcrumbName: deviceName,
                    path: generatePath(routes.DeviceTab.path, { customerId: params.customerId }) + location.search,
                },
                { breadcrumbName: title },
            ]}
            title={title}
            loading={loading}
        >
            <AreaForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default AreaSavePage;
